import React from 'react';
import { TabPanel, TabView } from '@allygpo/ally-ux';

export interface TabStripTab {
  key: string;
  header: React.ReactNode;
}

interface TabStripProps {
  tabs: TabStripTab[];
  active: string;
  onChange: (key: string) => void;
  className?: string;
}

/**
 * A row of tabs that switches content rendered elsewhere, e.g. in a modal's sticky header or above a card's
 * table. Ally UX TabView headers (its styling and keyboard behaviour); its own panel area is hidden.
 */
const TabStrip: React.FC<TabStripProps> = ({ tabs, active, onChange, className }) => (
  <TabView
    // Full width so the tab rule spans the container even inside a flex row.
    className={`w-full${className ? ` ${className}` : ''}`}
    panelContainerClassName="hidden"
    activeIndex={Math.max(0, tabs.findIndex((tab) => tab.key === active))}
    onTabChange={(event) => onChange(tabs[event.index].key)}
  >
    {tabs.map((tab) => <TabPanel key={tab.key} header={tab.header} />)}
  </TabView>
);

export default TabStrip;
